import { Tab, Spinner, SpinnerSize } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";
import { ERoutes } from "../../../ERoutes";
import { BackButton, PageBase, ProtectedTabs } from "../../../components";
import { useApiService, useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";
import { ClinicDetailsPage } from "./ClinicDetailsPage";
import { ClinicApi } from "../../../api";
import { ClinicVeterinariesPage } from "./ClinicVeterinaries/ClinicVeterinariesPage";

export interface IClinicItemPageProps {}
export const ClinicItemPage: React.FunctionComponent<IClinicItemPageProps> = (props) => {
  const { id, tab, state } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();
  const { t } = useTl();
  const api = useApiService(ClinicApi);
  const [displayName, loading] = useApiEffect(() => api.getDisplayName(+id), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Clinics), route: ERoutes.clinic },
        { text: +id > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="TabsClinic"
        onChange={(newTabId) => history.push(`${ERoutes.clinic}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.clinic} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<ClinicDetailsPage clinicId={+id} editMode={state === "edit"} />}
        />
        <Tab
          id="veterinary"
          title={t(ETLCodes.Veterinarians)}
          panel={<ClinicVeterinariesPage editMode={state === "edit"} />}
          disabled={+id <= 0}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
